import reviewerType from "./reviewer-type";

export default [...reviewerType];
